import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faUpRightFromSquare';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AtiraEmptyWithAction } from '../../../components/AtiraEmptyWithAction';
import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { atiraLinkSliceSelectors } from '../../../redux/atira-link/atira-link.selector';
import { AtiraLinkActions } from '../../../redux/atira-link/atira-link.slice';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { userSliceSelectors } from '../../../redux/user/user.selector';
import { DashboardWidget } from './DashboardWidget';

export const DashboardAtiraLinkWidget: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const stats = useAppSelector(
    atiraLinkSliceSelectors.selectSelectedAtiraLinkStats,
  );

  const visits = (stats?.MOBILE.view || 0) + (stats?.DESKTOP.view || 0);
  const clicks = (stats?.MOBILE.click || 0) + (stats?.DESKTOP.click || 0);
  const countriesCount = stats?.COUNTRIES.length || 0;
  const clickedSocialsCount =
    stats?.SOCIAL.filter((s) => s.count > 0).length || 0;
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const userLinks = useAppSelector(
    atiraLinkSliceSelectors.selectUserAtiraLinks,
  );

  useEffect(() => {
    dispatch(AtiraLinkActions.getUserAtiraLinks({ userId }));
  }, [dispatch, userId]);

  return (
    <DashboardWidget
      title={t('dashboard.widget.atiraLink.title')}
      titleIcon={faUpRightFromSquare}
      mainAction={{
        title: t('dashboard.widget.atiraLink.action'),
        icon: faPen,
        onClick: () => navigate('/my-link'),
      }}
      moreActionLink={'/analytics'}
      showActions={Boolean(userLinks.length)}
    >
      {userLinks.length ? (
        <Flex flexDirection="column" gap="m" padding="m">
          <Text>
            <Trans
              i18nKey={'dashboard.widget.atiraLink.views'}
              values={{ count: visits }}
              components={[<strong />]}
            />
          </Text>

          <Text>
            <Trans
              i18nKey={'dashboard.widget.atiraLink.clicks'}
              values={{ count: clicks }}
              components={[<strong />]}
            />
          </Text>

          <Text>
            <Trans
              i18nKey={'dashboard.widget.atiraLink.countries'}
              values={{ count: countriesCount }}
              components={[<strong />]}
            />
          </Text>

          <Text>
            <Trans
              i18nKey={'dashboard.widget.atiraLink.socials'}
              values={{ count: clickedSocialsCount }}
              components={[<strong />]}
            />
          </Text>
        </Flex>
      ) : (
        <Flex padding="xl" justifyContent="center" height={'150px'}>
          <AtiraEmptyWithAction
            buttonTitle={t('common.create')}
            description={t('dashboard.widget.atiraLink.empty.title')}
            onClick={() => navigate('/my-link')}
            buttonWidth="16rem"
          />
        </Flex>
      )}
    </DashboardWidget>
  );
};
